import { useTranslation } from 'react-i18next';

import { normalizeMessage } from '../actions';
import { WIDGET_URL } from 'widget/constants/widget-url';
import * as Env from 'widget/env';

const userpic = `${WIDGET_URL}/static/img/manager.svg`;

const useDefaultMessages = (): Env.Message[] => {
  const { t } = useTranslation();

  const name = t`Manager`;

  const messages = [
    normalizeMessage(t`Hello!`, name, userpic),
    normalizeMessage(t`How may I help you?`, name, userpic),
  ];

  return messages;
};

export default useDefaultMessages;
